import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AutoKeyBusinessService } from 'projects/Administration/src/app/business-services/auto-key.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { NgbdSortableHeader } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';

@Component({
  selector: 'app-sharebox-log',
  templateUrl: './sharebox-log.component.html',
  styleUrls: ['./sharebox-log.component.css']
})
export class ShareboxLogComponent implements OnInit {

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  shareboxLog: any[] = [];
  autoKeyDetailData: any;
  customerKeyDropData: any;
  isShareboxPaymentMethod: boolean = false;
  autoKeyDetailId: any;
  isLatestKeyPickUp: boolean = false;
  userDetail: any;
  shareBoxLogData: any;
  appointmentId: number;
  parkingDetails: string;
  isKeyPickupWithoutPayment: boolean;
  parkingDetailsPopup:any;
  keyPopupToggle:boolean;
  constructor(
    private readonly editAppointmentService: EditAppointmentService,
    private readonly activeModal: NgbActiveModal,
    private readonly toastr: ToastrService,
    private readonly autoKeyService: AutoKeyBusinessService,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.appointmentId = this.editAppointmentService.appointmentDetails.id;
    this.getShareboxLogData(this.appointmentId);
  }

  async getShareboxLogData(appointmentId: number) {
    try {
      this.spinner.show();
      const response = await this.autoKeyService.getShareboxLogData(appointmentId);
      if (response && response.shareBoxLogView?.length > 0) {
        this.spinner.hide();
        this.shareBoxLogData = response.shareBoxLogView
        this.autoKeyDetailData = response.autoKeyDetail

        // Loop through shareBoxLogData and convert eventDateTime to local timezone
        this.shareBoxLogData = this.shareBoxLogData.map((item: any) => {
          const localEventDateTime = Utility.ConvertUTCDateToLocalDate(item.eventDateTime);
          const UserName = item.displayName == null ? 'Customer' : item.displayName;
          return {
            ...item,
            eventDateTime: localEventDateTime,
            displayName: UserName
          };
        });

        const maxDate = this.shareBoxLogData.length ? Math.max(
          ...this.shareBoxLogData
            .map((item: any) => {
              const date = new Date(item.eventDateTime);
              return isNaN(date.getTime()) ? -Infinity : date.getTime();
            })
        ) : null;

        this.shareBoxLogData = this.shareBoxLogData.map((item: any) => ({
          ...item,
          isLatest: new Date(item.eventDateTime).getTime() === maxDate,
        }));

        const latestItem = this.shareBoxLogData.find(
          (item: any) => new Date(item.eventDateTime).getTime() === maxDate
        );
        this.isLatestKeyPickUp = (latestItem?.eventName?.includes('Key Drop') || latestItem?.eventName?.includes('Customer Key Drop')) ?? false;
        this.isKeyPickupWithoutPayment = (latestItem?.isKeyPickupWithoutPayment) ?? false;

        const customerKeyDropData = this.autoKeyDetailData.find(item => item.keyPickUpDate == null);

        if (customerKeyDropData) {
          this.customerKeyDropData = customerKeyDropData;
          this.autoKeyDetailId = customerKeyDropData.id;
        }
      }
    }
    catch (error) {
      let msg = this.translate.instant("lblErrorFetchingShareboxLogData"); 
      this.handleError(msg, error);
    }
    finally {
      this.spinner.hide();
    }
  }

  async onOpenLocker(autoKeyId: number): Promise<void> {
    if (!autoKeyId) {
      let msg = this.translate.instant("lblInvalidLockerID"); 
      this.toastr.error(msg);
      return;
    }

    try {
      this.spinner.show();
      const res = await this.autoKeyService.openLocker(autoKeyId, this.appointmentId);

      if (res.responseObject) {
        await this.getShareboxLogData(this.appointmentId);
        let msg = this.translate.instant("lblLockerOpenedSuccessfully"); 
        this.toastr.success(msg);
      } else {
        let msg = this.translate.instant("lblFailedToOpenLocker"); 
        this.toastr.error(msg);
      }
    } catch (error) {
      let msg = this.translate.instant("lblErrorOpeningLocker"); 
      this.handleError(msg, error);
    } finally {
      this.spinner.hide();
    }
  }

  // Improved locker reservation with better error handling
  async onReserveLocker(sentSMS:boolean): Promise<void> {
    if (this.appointmentId <= 0) {
      let msg = this.translate.instant("lblInvalidAppointmentID"); 
      this.toastr.error(msg);
      return;
    }

    try {
      this.spinner.show();
      const response = await this.autoKeyService.GetAppointmentByDealerIdAndAppointmentId(
        this.editAppointmentService.appointmentDetails.dealerId,
        this.appointmentId
      );

      if (response.length > 0) {
        const viewModel = {
          dealerId: this.editAppointmentService.appointmentDetails.dealerId,
          AppointmentId: this.appointmentId,
          IsShareboxPaymentMethod: this.isShareboxPaymentMethod,
          FinalInvoiceAmount: response[0].finalInvoiceAmount || 0.0,
          isSentSMS: sentSMS,
          parkingDetails:sentSMS ? this.parkingDetails : ''
        };

        const res = await this.autoKeyService.AssignLockerToOrder(viewModel);

        if (res.responseObject) {
          await this.getShareboxLogData(this.appointmentId);

          if (!this.editAppointmentService.appointmentDetails.sentShareboxInfo) {
            this.editAppointmentService.appointmentDetails.sentShareboxInfo = res.responseObject;
          }
          let msg = this.translate.instant("lblLockerReservedSuccessfully");   
          this.toastr.success(msg);
        }
      }
    } catch (error) {
      let msg = this.translate.instant("lblErrorReservingLocker"); 
      this.handleError(msg, error);
    } finally {
      this.spinner.hide();
    }
  }

  // Generic error handling method
  private handleError(message: string, error: unknown): void {
    this.toastr.error(message);
    this.spinner.hide();
  }

  OnClose(modal:any) {
    this.isKeyPickupWithoutPayment = false;
    this.keyPopupToggle = false;
    modal.dismiss('dismissed');
  }
  openParkingDetailsPopup(event: any, viewContent: any){
    this.keyPopupToggle = !this.keyPopupToggle;
    if(this.keyPopupToggle){
      this.parkingDetailsPopup = this.modalService.open(viewContent, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {
      }, (reason) => {
        if(reason.success){
          this.onReserveLocker(true);
        }
      });
    }
  }
}
